

























































import Vue from 'vue';
import {RequestSession} from "@/interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import {AttributeValue} from "@/interfaces/donation/attributeValue";
import DonationDetailsFormComponent from "@/components/donation/DonationDetailsFormComponent.vue";
import BasicDonationDetailsFormComponent from "@/components/donation/BasicDonationDetailsFormComponent.vue";
import { isMemoryGift, Type, isContribution } from '@/classes/DonationType';
import {AttributeType} from "@/enums/attributeType";
import {cleanTextFromTrailingEmptyRows, countRowsInTextArea} from "@/utils";

export default Vue.extend({
  components: {
    DonationDetailsFormComponent,
    BasicDonationDetailsFormComponent
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    showPrev: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      exampleMessages: this.$t('exampleMessages'),
      lazy: true,
      valid: true,
      dialog: false,
      donationDetails: {
        attributeValues: [
          {
            value: "",
            attributeId: AttributeType.SUBJECT_NAME
          },
          {
            value: "",
            attributeId: AttributeType.GREETING
          },
          {
            value: "",
            attributeId: AttributeType.DONOR_NAME
          }
        ] as Array<AttributeValue>,
        donationCause: null,
        donationImageId: null
      } as Donation,
      showCause: false,
      images: [],
      categories: [],
      noSenderName: false,
      rules: {},
      textAreaValidation: {
        message: {
          maxRowSize: 130,
        },
        donorNames: {
          maxRowSize: 125
        },
        maxTotalRowCount: 17,
        valid: true,
      },
      attributes: {
        subjectName: AttributeType.SUBJECT_NAME,
        greeting: AttributeType.GREETING,
        donorName: AttributeType.DONOR_NAME
      }
    };
  },
  computed: {
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    isMemoryGift(): boolean {
      return this.donation && isMemoryGift(this.donation.donationType.type)
    },
    isContribution(): boolean {
      return this.donation && isContribution(this.donation.donationType.type)
    },
    tooManyAttributeRows() {
      return this.donationDetails && this.isMemoryGift && !this.hasValidAttributeRowCount();
    }
  },
  methods: {
    next() {
      if (!this.$refs.form.validate()) {
        // TODO: Break out and reuse for other form steps
        for (var i = 0; i < this.$refs.form.$children.length; i++) {
          const child = this.$refs.form.$children[i];
          if (child.valid === false) {
            this.$vuetify.goTo(child, {offset: 100});
          }
        }
        return;
      }

      let donation: Donation = this.donation
      if (this.isMemoryGift) {
        this.cleanAttributeTexts();
        donation.attributeValues = this.donationDetails.attributeValues
        donation.donationImageId = this.donationDetails.donationImageId
      }

      donation.donationCause = this.donationDetails.donationCause
      donation.showCondolenceOnMemorialPage = this.donationDetails.showCondolenceOnMemorialPage
      this.$store.commit('updateDonation', donation)
      this.$emit('nextStep');
    },
    hasValidAttributeRowCount() {
      let message = this.getAttributeValueById(AttributeType.GREETING);
      let donorNames = this.getAttributeValueById(AttributeType.DONOR_NAME);

      let totalRows = (countRowsInTextArea(message, this.textAreaValidation.message.maxRowSize) + countRowsInTextArea(donorNames, this.textAreaValidation.donorNames.maxRowSize));
      return totalRows <= this.textAreaValidation.maxTotalRowCount;
    },
    cleanAttributeTexts() {
      let greetingAttribute = cleanTextFromTrailingEmptyRows(this.getAttributeValueById(this.attributes.greeting))
      this.setAttributeValueById(this.attributes.greeting, greetingAttribute, false);

      let namesAttribute = cleanTextFromTrailingEmptyRows(this.getAttributeValueById(this.attributes.donorName))
      this.setAttributeValueById(this.attributes.donorName, namesAttribute, false);
    },
    getAttributeValueById(id: number): string {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);
      return attributeValue ? attributeValue.value : "";
    },
    setAttributeValueById(id: number, value, concat: boolean) {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);

      if (attributeValue) {
        if (concat) {
          attributeValue.value += value;
        } else {
          attributeValue.value = value
        }
      }
    }
  },
});
